import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import OffersSection from './components/OffersSection';
import SocialLinks from './components/SocialLinks';
import SEOHead from '../../components/SEO/SEOHead';
import StructuredData from '../../components/SEO/StructuredData';
import { offerte } from '../../mocks/offers';

const OffertePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://agro-innovazioni.it';
  
  const itemListData = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Offerte AGRO-INNOVAZIONI',
    description: 'Promozioni speciali su spezie biologiche e biscotti biologici',
    url: `${siteUrl}/offerte`,
    itemListElement: offerte.map((offerta, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Product',
        name: offerta.prodotto,
        description: offerta.descrizione,
        image: offerta.immagine,
        offers: {
          '@type': 'Offer',
          price: offerta.prezzoScontato.toString(),
          priceCurrency: 'EUR',
          availability: 'https://schema.org/InStock',
          validFrom: new Date().toISOString(),
          priceValidUntil: offerta.validoFino,
        },
        brand: {
          '@type': 'Brand',
          name: 'AGRO-INNOVAZIONI',
        },
      },
    })),
  };

  const webPageData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Offerte - Promozioni su Prodotti Biologici | AGRO-INNOVAZIONI',
    description: 'Scopri le nostre offerte speciali su spezie biologiche e biscotti da tisana. Qualità garantita a prezzi vantaggiosi.',
    url: `${siteUrl}/offerte`,
    mainEntity: itemListData,
  };

  return (
    <>
      <SEOHead
        title="Offerte - Promozioni su Prodotti Biologici | AGRO-INNOVAZIONI"
        description="Scopri le nostre offerte speciali su spezie biologiche e biscotti da tisana. Qualità garantita a prezzi vantaggiosi."
        keywords="offerte spezie biologiche, promozioni biscotti bio, sconti prodotti bio, offerte del mese"
        ogTitle="Offerte - Promozioni su Prodotti Biologici | AGRO-INNOVAZIONI"
        ogDescription="Scopri le nostre offerte speciali su spezie biologiche e biscotti da tisana. Qualità garantita a prezzi vantaggiosi."
        ogImage="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/f44ef6b76bca892c4b2b8ad1895f9c04.jpeg"
        ogType="website"
        canonical={`${siteUrl}/offerte`}
      />
      <StructuredData type="WebPage" data={webPageData} />
      <StructuredData type="ItemList" data={itemListData} />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <OffersSection />
          <SocialLinks />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default OffertePage;
